import { render, staticRenderFns } from "./ObjectFrame.vue?vue&type=template&id=1d1cabc7&"
import script from "./ObjectFrame.vue?vue&type=script&lang=js&"
export * from "./ObjectFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports